"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatServerErrorMsg = void 0;
const formatServerErrorMsg_util_1 = require("./formatServerErrorMsg/formatServerErrorMsg.util");
Object.defineProperty(exports, "formatServerErrorMsg", { enumerable: true, get: function () { return formatServerErrorMsg_util_1.formatServerErrorMsg; } });
